export function addCurrent(activity) {
    return {
        type: 'ADD_CURRENT',
        activity,
    }
}
